import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Only redirects, so any signed-in user may open it: the dashboard checks its own access.
export const Route = createFileRoute('/_authenticated/projects/$projectId/')({
    staticData: { access: 'authenticated', chrome: 'project' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/dashboard',
            params: { projectId: params.projectId },
            replace: true,
        });
    },
});
